import React from "react";
import "./App.css";

function Navbar() {
	return (
		<nav className="navbar">
			<div className="navbar-content">
				<div className="navbar-logo">
					<a href="/">
						<img src="/logo.png" alt="Logo" style={{ height: "50px" }} />
					</a>
				</div>
				<div className="navbar-links-container">
					<ul className="navbar-links">
						<li>
							<a href="/about">About</a>
						</li>
						<li>
							<a href="/services">Classes</a>
						</li>
						<li>
							<a href="/contact">Contact</a>
						</li>
					</ul>
				</div>
				<div className="navbar-socials">
					<a
						href="https://www.instagram.com/firstphilosophyinstitute/?hl=en"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src="/instagram.png" alt="Instagram" />
					</a>
					<a
						href="https://www.linkedin.com/company/first-philosophy-institute/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src="/linkedin.png" alt="LinkedIn" />
					</a>
					<a
						href="https://www.facebook.com/profile.php?id=61573585827666"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src="/facebook.png" alt="Facebook" />
					</a>
					<a
						href="https://gabrielhigazi.substack.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src="/substack.svg" alt="Substack" />
					</a>
					<a
						href="https://www.youtube.com/@FirstPhilosophyInstitute"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src="/youtube.png" alt="YouTube" />
					</a>
				</div>
			</div>
		</nav>
	);
}

export default Navbar;
